module.exports = __webpack_public_path__ + "dog.1e0f3cb6.png";